var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-container",class:{ 'event-container-selected': _vm.eventId == _vm.item._id },on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"event-title"},[_vm._v(_vm._s(_vm.item.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }